import { Link } from 'react-router-dom';
import type { Film } from '@/types/content';

type FilmCardProps = {
  film: Film;
  index?: number;
};

export default function FilmCard({ film, index = 0 }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group block cursor-pointer animate-rise"
      style={{ animationDelay: `${Math.min(index, 8) * 45}ms` }}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg border border-background-300/70 bg-background-200">
        <img
          src={film.cover}
          alt={`${film.title} 影片封面`}
          title={`${film.title} · 成人影视条目`}
          className="h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-[1.05]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/85 via-background-50/10 to-transparent opacity-70 transition-opacity duration-300 group-hover:opacity-95" />
        <span className="absolute left-2.5 top-2.5 flex items-center gap-1 rounded-md bg-background-50/85 px-1.5 py-0.5 font-label text-[11px] text-primary-400 backdrop-blur-sm">
          <i className="ri-star-fill text-[10px]" />
          {film.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2.5 left-2.5 right-2.5 flex items-center justify-between gap-2">
          <span className="rounded bg-background-50/80 px-1.5 py-0.5 font-label text-[10px] tracking-wider text-foreground-700 backdrop-blur-sm">
            {film.year}
          </span>
          <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-background-50 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <i className="ri-arrow-right-line text-xs" />
          </span>
        </span>
      </div>
      <div className="pt-3">
        <h3 className="truncate text-[14px] font-medium text-foreground-900 transition-colors group-hover:text-primary-400">
          {film.title}
        </h3>
        <p className="mt-1 truncate text-[11px] text-foreground-500">
          {film.region} · {film.subcategory}
        </p>
      </div>
    </Link>
  );
}